import React from 'react'
import MaterialSymbol from '../material-symbol'

const PlaylistAddCheck = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="playlist_add_check" {...props} />
))

PlaylistAddCheck.displayName = 'PlaylistAddCheck'

export default PlaylistAddCheck
